import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ConstantValues } from 'src/app/bpg-common/models/bpg-constants';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { BpgEventsService } from 'src/app/bpg-events/bpg-events.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { BpgExpensesService } from '../bpg-expenses.service';
import { NgSelectComponent } from '@ng-select/ng-select';
import { BpgCommonService } from 'src/app/bpg-common/services/bpg-common.service';
import { buildFiscalYearOptions } from 'src/app/omnidashboard/core/omnidashboard-fiscal-year';

@Component({
  selector: 'app-actuals',
  templateUrl: './actuals.component.html',
  styleUrls: ['./actuals.component.css']
})
export class ActualsComponent implements OnInit {

  @ViewChild('dropdown', { static: false }) dropdown!: NgSelectComponent;

  actualsDataList: any[] = [];
  limit: number = ConstantValues.pageLimit;
  currentShowingElements: number = ConstantValues.pageLimit;
  landingData: any;
  currentPage = 1;
  numberOfElements: number;
  tableShow: boolean;
  noDataFound: boolean;
  timeOutError: boolean;
  isConsolidatedSelected = true;
  isDetailedBreakdownSelected = false;
  chapterList: any;
  selectedChapter: any;
  selectedChapterId: any;
  quarter = '';
  private readonly currentFy = buildFiscalYearOptions().selectedFiscalYear;
  private readonly priorFy = String(+this.currentFy - 1);
  fiscalYear = this.priorFy;
  fyLabels = [this.priorFy.slice(-2), this.currentFy.slice(-2)];
  fyValues = [this.priorFy, this.currentFy];
  type = 'DASHBOARD';
  chapterCombination = '';
  isErgSelected: any;
  isChapterSelected: any;
  isSiteSelected: any;
  ergList: any;
  selectedErg: any;
  selectedErgId = '0';
  siteList: any;
  selectedSite: any;
  selectedSiteId: any;
  total = { fiscalQtr: '', chapterApprovedAmount: 0, budget: 0, spent: 0, ergDiscrepancy: 0, plannedVsActual: 0 };
  selectAllConstant = 'Select All';
  userAndRoleIdDTO: any;
  loginData: any = JSON.parse(localStorage.getItem('loginData'));
  adminId: any = localStorage.getItem('adminId');
  myChapterIds: any;
  storedData: any;
  isMultiChapterAdmin: boolean;
  myChapterNames: any;
  lastUpdatedDate = 'July 07, 2026';
  printFlag = 'ByChapter';

  constructor(private readonly spinner: Ng4LoadingSpinnerService,
    private readonly router: Router,
    private readonly bpgEventsService: BpgEventsService,
    private readonly bpgExpenseService: BpgExpensesService,
    private readonly environment: EnvironmentConfiguration,
    private readonly bpgCommonService: BpgCommonService
  ) { }

  ngOnInit() {
    this.spinner.show();
    this.logUserAction();
    if (this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod') {
      if (localStorage.getItem('loginData') === null || localStorage.getItem('loginData') === undefined) {

        this.router.navigate(['/log-out']);
      }
    }
    if (localStorage.getItem('logOutFlag') === "true") {
      this.router.navigate(['/log-out']);
    }
    this.isMultiChapterAdmin = localStorage.getItem('isMultiChapterAdmin') === 'true';

    this.init();
  }

  async init() {
    await this.myChapters();
    await this.getActualsChapters();
    this.getActualsErg();
    this.getActualsSite();

    this.isErgSelected = false;
    this.isSiteSelected = false;
    this.isChapterSelected = true;

    this.spinner.show();
    this.consolidated();
  }

  pageChanged(event) {
    this.landingData.page = event - 1;
    this.currentPage = event;

    if ((this.currentPage * this.limit) < this.numberOfElements) {
      this.currentShowingElements = this.currentPage * this.limit;
    } else if ((this.currentPage * this.limit) > this.numberOfElements) {
      this.currentShowingElements = this.numberOfElements;
    }
    this.getActualDataList();
  }
  async getActualDataList() {
    if (!this.chapterList) {
      await this.getActualsChapters();
    }
    if (this.selectedChapterId == null) {
      this.selectedChapterId = this.myChapterIds;
    }
    if (this.isConsolidatedSelected) {
      const chapterIdForPayload = this.selectedChapterId;
      if (Array.isArray(chapterIdForPayload)) {
        this.selectedChapterId = chapterIdForPayload.join(',');
      }
      if (this.isErgSelected) {
        this.landingData = {
          "filter": {
            "QUARTER": this.quarter,
            "FY": this.fiscalYear,
            "flag": this.type,
            "chapterFilterFlag": "bpg",
            "bpgId": this.selectedErgId
          },
          "moduleId": 0,
          "page": this.currentPage - 1,
          "presentRole": "",
          "searchTerm": "",
          "size": this.limit,
          "uid": "",
          "sortProperty": "chapter_id",
          "sortDirection": "ASC"
        }
      } else if (this.isSiteSelected) {
        this.landingData = {
          "filter": {
            "QUARTER": this.quarter,
            "FY": this.fiscalYear,
            "flag": this.type,
            "chapterFilterFlag": "site",
            "siteId": this.selectedSiteId
          },
          "moduleId": 0,
          "page": this.currentPage - 1,
          "presentRole": "",
          "searchTerm": "",
          "size": this.limit,
          "uid": "",
          "sortProperty": "chapter_id",
          "sortDirection": "ASC"
        }
      }
      else {
        if (this.isMultiChapterAdmin && (this.adminId !== '1')) {
          this.landingData = {
            "filter": {
              "QUARTER": this.quarter,
              "FY": this.fiscalYear,
              "flag": this.type,
              "chapterFilterFlag": "chapter",
              "chapterId": this.selectedChapterId,
              "multiChapterAdmin": "true"
            },
            "moduleId": 0,
            "page": this.currentPage - 1,
            "presentRole": "",
            "searchTerm": "",
            "size": this.limit,
            "uid": "",
            "sortProperty": "chapter_id",
            "sortDirection": "ASC"
          }
        } else {
          this.landingData = {
            "filter": {
              "QUARTER": this.quarter,
              "FY": this.fiscalYear,
              "flag": this.type,
              "chapterFilterFlag": "chapter",
              "chapterId": this.selectedChapterId,
            },
            "moduleId": 0,
            "page": this.currentPage - 1,
            "presentRole": "",
            "searchTerm": "",
            "size": this.limit,
            "uid": "",
            "sortProperty": "chapter_id",
            "sortDirection": "ASC"
          }
        }
      }
    }
    else {
      this.landingData = {
        "filter": {
          "QUARTER": this.quarter,
          "FY": this.fiscalYear,
          "flag": this.type,
          "chapterCombination": this.chapterCombination
        },
        "moduleId": 0,
        "page": this.currentPage - 1,
        "presentRole": "",
        "searchTerm": "",
        "size": this.limit,
        "uid": ""
      }

    }
    this.bpgEventsService.getBudgetActualsData(this.landingData).subscribe(data => {
      this.timeOutError = false;
      if (this.chapterList.length === 0) {
        this.actualsDataList = [];
        this.numberOfElements = 0;
      }
      else {
        this.actualsDataList = data.content;
        this.numberOfElements = data.totalElements;
      }
      if (this.actualsDataList.length === 0) {
        this.tableShow = false;
        this.noDataFound = true;
      } else {
        this.tableShow = true;
        this.noDataFound = false;
        this.totalReset();

        for (const data of this.actualsDataList) {
          data.plannedVsActual = (data.chapterApprovedAmount - data.spent);
          data.printPvsA = data.plannedVsActual;
          if (this.isErgSelected || this.isSiteSelected) {
            this.total.ergDiscrepancy = this.total.ergDiscrepancy + data.difference;
            this.total.chapterApprovedAmount = this.total.chapterApprovedAmount + data.chapterApprovedAmount;
            this.total.budget = this.total.budget + data.budget;
            this.total.spent = this.total.spent + data.spent;
            this.total.plannedVsActual = this.total.plannedVsActual + data.plannedVsActual;
          }
          if (data.difference < 0) {
            data.symbolRed = true;
            data.symbolGreen = false;
            data.ergDiscrepancy = (-1) * data.difference;
          }
          else {
            data.symbolGreen = true;
            data.symbolRed = false;
            data.ergDiscrepancy = data.difference;
          }

          if (data.plannedVsActual < 0) {
            data.symbolRed1 = true;
            data.symbolGreen1 = false;
            data.plannedVsActual = (-1) * data.plannedVsActual;
          }
          else {
            data.symbolGreen1 = true;
            data.symbolRed1 = false;
          }
          data.fiscalQtr = `FY${data.fiscalYear.slice(-2)}` + ((this.quarter !== '') ? (' - ' + this.quarter) : '');
        }
        if (this.isErgSelected || this.isSiteSelected) {
          this.total.fiscalQtr = `FY${this.fiscalYear.slice(-2)}` + ((this.quarter !== '') ? (' - ' + this.quarter) : '');
        }
      }
      this.spinner.hide();
    }, err => {
      this.spinner.hide();
      if (err.value.statusText === ConstantValues.unknownError) {
        this.timeOutError = true;
      }
    });
  }

  async getActualsChapters() {
    if (this.myChapterIds === undefined) {
      this.myChapterIds = await this.myChapters().then();
    }
    return new Promise<void>((resolve) => {
      this.bpgExpenseService.getActualsChapterList().subscribe(data => {
        for (const d of data) {
          d.modChapterName = d.chapterName.replace(/-/g, ' ').replace(/\s+/g, ' ').trim().toUpperCase();
        }
        if (this.adminId === '1' || this.adminId === 1) {
          this.chapterList = data;
          // this.chapterList.unshift({ chapterId: this.myChapterIds, modChapterName: this.selectAllConstant.toUpperCase() });
        }
        else {
          this.chapterList = data.filter(chapters => this.myChapterIds.includes(chapters.chapterId));
          this.myChapterNames = this.chapterList.map(chapter => chapter.chapterName).join(', ');
        }
        this.myChapterIds = '';
        for (const c of this.chapterList) {
          if (this.myChapterIds === '') {
            this.myChapterIds = this.myChapterIds + c.chapterId;
          } else {
            this.myChapterIds = `${this.myChapterIds},${c.chapterId}`;
          }
        }
        this.selectedChapterId = this.myChapterIds;
        this.chapterCombination = this.myChapterNames;
        resolve(this.chapterList);
      }, err => {
        this.spinner.hide();
        if (err.value.statusText === ConstantValues.unknownError) {
          this.timeOutError = true;
        }
      });
    });
  }

  getActualsErg() {
    this.bpgExpenseService.getActualsBPGList().subscribe(data => {
      this.ergList = data;
      this.ergList.unshift({ bpgId: 0, bpgName: this.selectAllConstant.toUpperCase() });
    }, err => {
      this.spinner.hide();
      if (err.value.statusText === ConstantValues.unknownError) {
        this.timeOutError = true;
      }
    });
  }

  getActualsSite() {
    this.bpgExpenseService.getActualsSiteList().subscribe(data => {
      this.siteList = data;
      this.siteList.unshift({ siteId: 0, siteName: this.selectAllConstant.toUpperCase() });
    }, err => {
      this.spinner.hide();
      if (err.value.statusText === ConstantValues.unknownError) {
        this.timeOutError = true;
      }
    });
  }

  consolidated() {
    this.resetFilter();
    this.currentPage = 1;
    this.currentShowingElements = 10; // showing elements (out of) fixed
    this.isConsolidatedSelected = true;
    this.isDetailedBreakdownSelected = false;
    this.type = 'DASHBOARD';
    this.quarter = '';
    this.fiscalYear = '2026';
    if (this.adminId === '1') {
      if (!this.isSiteSelected && this.isErgSelected && !this.isChapterSelected) {
        this.selectedErgId = '0';
        this.currentShowingElements = 100;
        this.limit = 100;
      } else if (this.isSiteSelected && !this.isErgSelected && !this.isChapterSelected) {
        this.selectedSiteId = 0;
        this.currentShowingElements = 100;
        this.limit = 100;
      }
      else {
        this.selectedChapterId = this.myChapterIds;
      }
    } else {
      this.selectedChapterId = this.myChapterIds;
    }
    this.getActualDataList();
  }

  detailedBreakdown() {
    this.resetFilter();
    this.dropdown.clearModel();
    this.isChapterSelected = true;
    this.isErgSelected = false;
    this.isSiteSelected = false;
    this.currentPage = 1;
    this.limit = 10;
    this.currentShowingElements = 10;
    this.printFlag = 'ByChapter';
    this.isConsolidatedSelected = false;
    this.isDetailedBreakdownSelected = true;
    this.isErgSelected = false;
    this.type = 'DETAILEDBREAKDOWN';
    this.quarter = '';
    this.fiscalYear = '2026';
    if (this.adminId === '1') {
      this.chapterCombination = '';
    } else {
      this.chapterCombination = this.myChapterNames;
    }
    this.getActualDataList();
  }

  chapterChange(event) {
    if (event) {
      this.currentPage = 1;
      this.limit = 10;
      this.currentShowingElements = 10;
      this.selectedChapterId = null;
      this.selectedChapterId = event.chapterId;
      this.quarter = '';
      this.chapterCombination = event.chapterName;
      if (this.chapterCombination === this.selectAllConstant) {
        this.chapterCombination = '';
      }
      this.getActualDataList();
    }
  }

  quarterSelected(quarter) {
    if (quarter === this.quarter) {
      this.quarter = '';// for toggle
    }
    else {
      this.quarter = quarter;
    }
    this.getActualDataList();
  }

  selectedFY(fiscalYear) {
    this.fiscalYear = fiscalYear; //hard coded for fiscal year
    this.quarter = '';
    this.selectedChapterId = this.myChapterIds;
    this.selectedErgId = '0';
    this.selectedSiteId = '0';
    this.chapterCombination = this.myChapterNames;
    this.dropdown.clearModel();
    this.getActualDataList();
  }

  ergChange(event) {
    if (event) {
      this.selectedErgId = null;
      this.selectedErgId = event.bpgId;
      this.quarter = '';
      this.limit = 100;
      this.currentShowingElements = 100;
      this.totalReset();
      this.getActualDataList();
    }
  }

  siteChange(event) {
    this.selectedSiteId = null;
    this.selectedSiteId = event.siteId;
    this.quarter = '';
    this.limit = 100;
    this.currentShowingElements = 100;
    this.totalReset();
    this.getActualDataList();
  }

  totalReset() {
    this.total.ergDiscrepancy = 0;
    this.total.chapterApprovedAmount = 0;
    this.total.budget = 0;
    this.total.spent = 0;
    this.total.plannedVsActual = 0;
    this.total.fiscalQtr = 'FY' + this.fiscalYear.slice(-2);
  }

  resetFilter() {
    this.type = '';
    this.quarter = '';
    this.fiscalYear = '';
    this.chapterCombination = '';
    this.selectedChapterId = '';
    this.selectedErgId = '';
    this.selectedSiteId = '';
    this.limit = 10;
    this.currentShowingElements = 10;
  }

  radioErgSelected() {
    this.isErgSelected = true;
    this.isChapterSelected = false;
    this.isSiteSelected = false;
    this.limit = 100;
    this.currentShowingElements = 100;
    this.printFlag = 'ByAffinity';
    this.dropdown.clearModel();
    this.consolidated();
  }

  radioChapterSelected() {
    this.isErgSelected = false;
    this.isChapterSelected = true;
    this.isSiteSelected = false;
    this.printFlag = 'ByChapter';
    this.dropdown.clearModel();
    this.consolidated();
  }

  radioSiteSelected() {
    this.isErgSelected = false;
    this.isChapterSelected = false;
    this.isSiteSelected = true;
    this.printFlag = 'BySite';
    this.dropdown.clearModel();
    this.consolidated();
  }

  async myChapters() {
    this.userAndRoleIdDTO = {
      userId: this.loginData['userId'],
      roleId: localStorage.getItem('adminId')
    };
    return new Promise<void>((resolve) => {
      this.bpgEventsService.getChapterDropDown(this.userAndRoleIdDTO).subscribe(data => {
        this.myChapterIds = data.map(item => item.chapterId);
        resolve(this.myChapterIds);
      }, err => {
        this.spinner.hide();
        if (err.value.statusText === ConstantValues.unknownError) {
          this.timeOutError = true;
        }
      });
    });
  }

  downloadActualsListAsExcel() {
    let exportData: any;
    let fileName = '';

    if (this.isConsolidatedSelected) {
      if (this.isChapterSelected) {
        const filteredData = this.actualsDataList.map(({
          chapterCombination,
          fiscalQtr,
          chapterApprovedAmount,
          budget,
          spent,
          printPvsA
        }) => ({
          Chapter: chapterCombination,
          FiscalYear: fiscalQtr,
          AnnualPlanApproved: chapterApprovedAmount,
          BudgetApprovedInERGConnect: budget,
          SAPActual: spent,
          ...(this.quarter === '' && { Available: printPvsA })
        }));
        exportData = filteredData;
      }
      else if (this.isErgSelected) {
        const filteredData = this.actualsDataList.map(({
          chapterCombination,
          fiscalQtr,
          chapterApprovedAmount,
          budget,
          spent,
          difference,
          printPvsA
        }) => ({
          ERG: chapterCombination,
          FiscalYear: fiscalQtr,
          AnnualPlanApproved: chapterApprovedAmount,
          BudgetApprovedInERGConnect: budget,
          SAPActual: spent,
          ...(this.adminId === '1' && { ERGDiscrepancy: difference }),
          ...(this.quarter === '' && { Available: printPvsA })
        }));
        exportData = filteredData;
      }
      else if (this.isSiteSelected) {
        const filteredData = this.actualsDataList.map(({
          chapterCombination,
          fiscalQtr,
          chapterApprovedAmount,
          budget,
          spent,
          printPvsA
        }) => ({
          Site: chapterCombination,
          FiscalYear: fiscalQtr,
          AnnualPlanApproved: chapterApprovedAmount,
          BudgetApprovedInERGConnect: budget,
          SAPActual: spent,
          ...(this.quarter === '' && { Available: printPvsA })
        }));
        exportData = filteredData;
      }
      fileName = `Actuals_Dashboard_${this.printFlag}_FY${this.fiscalYear}${this.quarter}`;
    }
    else if (this.isDetailedBreakdownSelected) {
      const filteredData = this.actualsDataList.map(({
        projectLevel03,
        projectLevel07,
        fiscalQtr,
        date,
        amount
      }) => ({
        Chapter: projectLevel03,
        WBSCode: projectLevel07,
        FiscalYear: fiscalQtr,
        Date: date,
        Amount: amount
      }));
      exportData = filteredData;
      fileName = `Actuals_DetailedBreakdown_FY${this.fiscalYear}${this.quarter}`;
    }
    this.bpgEventsService.exportAsExcelFile(exportData, fileName);
  }

  logUserAction() {
    const loginData = JSON.parse(localStorage.getItem("loginData"));
    const userId = loginData["userId"];
    const data = {
      userId: userId,
      categoryDescription: "Budget - Actuals",
    };
    this.bpgCommonService.logUserAction(data).subscribe((_data) => { });
  }

}
